(function() {
  /**
   * If an event is fired with the name 'broadCastName' this directive shows a
   * loading indicator if the values provided by the event ist true. The loading
   * indicator is hidden if false is provided. Such an event is fired if
   * app.startLoading is called with an event name.
   */
  angular.module('cfn').directive('loadingBroadcastHint', loadingBroadcastHint);

  function loadingBroadcastHint() {
    return {
      restrict: 'E',
      scope: {
        broadCastName: '@eventName',
        message: '@message'
      },
      template:
        '<div class="hint" ng-class="{\'loading\':isLoading, \'not-loading\':!isLoading}"><div class="message">{{message}}</div><div class="bar"></div></div>',
      link: function($scope) {
        $scope.isLoading = false;
        $scope.$on($scope.broadCastName, function(message, isLoading) {
          $scope.isLoading = isLoading;
        });
      }
    };
  }
})();
